<template>
  <div
    class="chart-container mt-1"
    @click="handleClick"
  >
    <div class="month-title dark-font">
      {{ title }}
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <e-charts
        ref="chart"
        autoresize
        :options="chartOptions"
        theme="theme-color"
        auto-resize
      />
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/pie'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    isSuccess: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'month',
    },
    startColor: {
      type: String,
      default: '#DADADB',
    },
    endColor: {
      type: String,
      default: '#DADADB',
    },
  },
  computed: {
    chartOptions() {
      return {
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            radius: ['70%', '90%'],
            label: {
              show: true,
              position: 'center',
              formatter: () => `${this.percentage}%`, // Display ONLY the given percentage
              fontSize: 14,
              fontWeight: 'bold',
            },
            data: [
              {
                value: this.percentage, // Only show this value
                name: this.isSuccess ? 'Success' : 'Failure',
                itemStyle: {
                  color: this.isSuccess
                    ? { // Apply gradient color
                      type: 'linear',
                      x: 1,
                      y: 0,
                      x2: 0,
                      y2: 0,
                      colorStops: [
                        { offset: 0, color: this.startColor }, // Start Color
                        { offset: 1, color: this.endColor }, // End Color
                      ],
                    }
                    : { // Apply gradient color
                      type: 'linear',
                      x: 1,
                      y: 0,
                      x2: 0,
                      y2: 0,
                      colorStops: [
                        { offset: 0, color: this.startColor }, // Start Color
                        { offset: 1, color: this.endColor }, // End Color
                      ],
                    },
                },
              },
              {
                value: (100 - this.percentage).toFixed(2), // This part should not display in the center
                name: 'Remaining',
                itemStyle: { color: '#DADADB' },
                label: { show: false }, // Hide label for this part
              },
            ],
          },
        ],
      }
    },
  },
  methods: {
    handleClick() {
      if (!this.isSuccess) {
        this.$emit('onClickFailure', this.label)
      }
    },
  },
}
</script>

<style scoped>
.chart-container {
    width: 115px;
    /* Adjust size */
    height: 150px;
    max-width: 135px;
    max-height: 170px;
    min-width: 105px;
    min-height: 140px;
    background-color: #4444440A;
    border-radius: 8px;
    cursor: pointer;
}

.echarts {
    width: 120px !important;
    height: 120px !important;
}

.month-title {
    font-size: 11px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #444444;
    margin-bottom: 5px;
    margin-top: 5px;
}
</style>
